<template>
	<div id="newsletter-subscribe" class="widget-subscribe">
		<ValidationObserver ref="observer" v-slot="{ invalid, pristine }">
			<form action="#" @submit.prevent="sendForm">
				<div class="form-group subscribe-email margin-bottom-30">
					<label for="subscribe-email">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							xmlns:xlink="http://www.w3.org/1999/xlink"
							version="1.1"
							x="0px"
							y="0px"
							viewBox="0 0 14 14"
							xml:space="preserve"
						>
							<g>
								<g>
									<path
										d="M7,9L5.268,7.484l-4.952,4.245C0.496,11.896,0.739,12,1.007,12h11.986 c0.267,0,0.509-0.104,0.688-0.271L8.732,7.484L7,9z"
										fill="#c4c4c4"
									/>
									<path
										d="M13.684,2.271C13.504,2.103,13.262,2,12.993,2H1.007C0.74,2,0.498,2.104,0.318,2.273L7,8 L13.684,2.271z"
										fill="#c4c4c4"
									/>
									<polygon points="0,2.878 0,11.186 4.833,7.079 " fill="#c4c4c4" />
									<polygon points="9.167,7.079 14,11.186 14,2.875 " fill="#c4c4c4" />
								</g>
							</g>
							<g />
							<g />
							<g />
							<g />
							<g />
							<g />
							<g />
							<g />
							<g />
							<g />
							<g />
							<g />
							<g />
							<g />
							<g />
						</svg>
					</label>
					<validation-provider v-slot="{ classes }" rules="required|email">
						<input
							id="subscribe-email"
							v-model="subscribeEmail"
							type="text"
							name="subscribe-email"
							class="form-control"
							:class="classes"
							:placeholder="$t('Misc.EnterYourEmailAddress')"
						/>
					</validation-provider>
				</div>

				<form-button
					:disabled="invalid || pristine || loading"
					:is-loading="loading"
					label="Button.Subscribe"
					component-class="button-3"
				></form-button>
			</form>
		</ValidationObserver>

		<newsletter-authorizations-modal :subscribe-email="subscribeEmail" />
	</div>
</template>

<script>
import AccountInfo from '@/mixins/AccountInfo'
import FormButton from '@/components/atoms/FormButton'
import ModalHelper from '@/mixins/ModalHelper'
import NewsletterAuthorizationsModal from '@/utils/modals/misc/NewsletterAuthorizationsModal'

export default {
	name: 'NewsletterSubscriptionForm',
	components: {
		FormButton,
		NewsletterAuthorizationsModal,
	},
	mixins: [AccountInfo, ModalHelper],
	data() {
		return {
			errors: {},
			loading: false,
			subscribeEmail: '',
		}
	},
	mounted() {
		// Listen for open modal submit event
		this.$root.$on('newsletter-authorizations-modal-submit', () => {
			this.subscribeEmail = ''

			// Reset form observer state
			requestAnimationFrame(() => {
				this.$refs.observer.reset()
			})
		})
	},
	destroyed() {
		// This prevents from having memory leaks
		this.$root.$off('newsletter-authorizations-modal-submit')
	},
	methods: {
		async sendForm() {
			if (this.isLoggedIn && this.subscribeEmail === this.account.email) {
				// Logged user (redirect to profile)
				this.$router.push({ name: 'profileNotifications' })
			} else {
				// Anonymous user (open modal for adding to newsletter user)
				const isValid = await this.$refs.observer.validate()
				if (!isValid) {
					return false
				}

				// Open newsletter authorizations modal
				this.openNewsletterAuthorizationsModal()
			}
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/newsletters/NewsletterSubscriptionForm.vue